import SocialsPresenter from "./SocialsPresenter";
import { CustomerDetails } from "src/features/hq/customers/models";
import { useState } from "react";
import { FormikProps, useFormik } from "formik";
import { useSearchParams } from "react-router-dom";
import { useHandleChange } from "@arelia-hooks/formikHooks";

type Props = {
  social: {
    name: string;
    url: string;
  }[];
  update: (cutomerUpdates: Partial<CustomerDetails>) => void;
};

export type EditForm = {
 [name: string]: string;
};

export default function SocialsContainer({ social, update }: Props) {
  const [searchParams] = useSearchParams();
  const [editing, setEditing] = useState(searchParams.get("edit") === "true");

  const mapper = (social: EditForm) => ({
    customerInfo: {
      social: Object.entries(social).map(([name, url]) => ({ name, url }))
    }
  } as Partial<CustomerDetails>);

  const submitUpdates = (updates: EditForm) => update(mapper(updates));

  const initialValues: EditForm = social.reduce((acc, curr) => ({
    ...acc,
    [curr.name]: curr.url
  }), {});

  const formik: FormikProps<EditForm> = useFormik<EditForm>({
    initialValues,
    onSubmit: submitUpdates,
    enableReinitialize: true,
  });

  const handeChange = useHandleChange<EditForm>(formik);

  return <SocialsPresenter
    formik={formik}
    handeChange={handeChange}
    editing={editing}
    setEditing={setEditing}
  />;
}